// Footer.js
import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";
import config from "../../config/Global.json";
import { AnnouncementFooterNews } from "./Announcements";
import { detectAppFromPath } from "./appRoutes";
import { useStore } from "../../context/StoreContext";
import AuthContext from "../../utils/secure-route/AuthContext";
import { useContext } from "react";

const PV_LOGO_URL = "https://paisavara.com/PVLOGO.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { version, appName } = config;
  const { pathname } = useLocation();
  const { currentStoreId } = useStore();
  const { user } = useContext(AuthContext);

  const hiddenFooterRoutes = [
    "/login",
    "/forgot-password",
    "/create-user",
    "/auth/pass-reset",
    "/reset-password",
  ];

  const shouldHideFooter = hiddenFooterRoutes.some((route) => pathname.startsWith(route));
  const storeId = currentStoreId || user?.store || null;
  const appKey = detectAppFromPath(pathname);

  if (shouldHideFooter) {
    return null;
  }

  return (
    <><AnnouncementFooterNews storeId={storeId} appKey={appKey} /><footer className="footer">
      <div className="footer-shell">
        <div className="footer-brand">
          <img src={PV_LOGO_URL} alt="PaisaVara" className="footer-image" />
          <div>
            <p className="footer-title">{appName}</p>
            <p className="footer-subtitle">Business workspace for smarter stores</p>
          </div>
        </div>

        <div className="footer-meta">
          <p className="footer-text">© {currentYear} {appName}. All rights reserved.</p>
          <span className="footer-version">Version {version}</span>
        </div>
      </div>
    </footer></>
  );
};

export default Footer;
